<template>
	<div class="contens">
		<!--  v-if="dpgl.length > 0" -->
		<div class="listBoxs" v-if="isdpgl">
			<div class="titles">
				店铺管理
			</div>
			<div class="boxCounts">
				<div class="boxs" v-for="(item,index) in dpgl" @click="openWindow(item.video)">
					<div class="imgbox">
						<img :src="item.thumb" alt="">
					</div>
					<div class="title">
						{{item.title}}
					</div>
				</div>
				
			</div>
		</div>
		
			
		<div class="listBoxs" v-if="isxxgl">
			<div class="titles">
				信息管理
			</div>
			<div class="boxCounts">
				<div class="boxs"  v-for="(dpItem,index) in xxgl" @click="openWindow(dpItem.video)">
					<div class="imgbox">
						<img :src="dpItem.thumb" alt="">
					</div>
					<div class="title">
						{{dpItem.title}}
					</div>
				</div>
			</div>
		</div>
		
			
		<div class="listBoxs" v-if="iszhgl">
			<div class="titles">
				展会管理
			</div>
			<div class="boxCounts">
				<div class="boxs"  v-for="(zhItem,index) in zhgl" @click="openWindow(zhItem.video)">
					<div class="imgbox">
						<img :src="zhItem.thumb" alt="">
					</div>
					<div class="title">
						{{zhItem.title}}
					</div>
				</div>
			</div>
		</div>
		<!-- 
			 -->
		<div :class="">
			<div v-if="ishyfw" :class="['listBoxs', key == 0 ?'litListBoxs':'' ] ">
				<div class="titles">
					会员服务
				</div>
				<div class="boxCounts">
					<div class="boxs"  v-for="(hyItem,index) in hyfw" @click="openWindow(hyItem.video)">
						<div class="imgbox">
							<img :src="hyItem.thumb" alt="">
						</div>
						<div class="title">
							{{hyItem.title}}
						</div>
					</div>
				</div>
			</div>
			
			
			<div v-if="isxtgg"  :class="[ 'listBoxs',key == 0 ?'litListBoxs':'' ] ">
				<div class="titles">
					系统公告
				</div>
				<div class="boxCounts">
					<div class="boxs"  v-for="(xtItem,index) in xtgl" @click="openWindow(xtItem.video)">
						<div class="imgbox">
							<img :src="xtItem.thumb" alt="">
						</div>
						<div class="title">
							{{xtItem.title}}
						</div>
					</div>
				</div>
			</div>
			
			
			<div v-if="islygl" :class="['listBoxs', key == 0 ?'litListBoxs':'' ]">
				<div class="titles">
					留言管理
				</div>
				<div class="boxCounts">
					<div class="boxs"  v-for="(lyItem,index) in lygl" @click="openWindow(lyItem.video)">
						<div class="imgbox">
							<img :src="lyItem.thumb" alt="">
						</div>
						<div class="title">
							{{lyItem.title}}
						</div>
					</div>
				</div>
			</div>
		</div>
		
		<div class="listBoxs" v-if="ishygl"  :class="['listBoxs', key == 0 ?'litListBoxs':'' ]">
			<div class="titles">
				会员管理
			</div>
			<div class="boxCounts">
				<div class="boxs"  v-for="(hyItem,index) in hygl" @click="openWindow(hyItem.video)">
					<div class="imgbox">
						<img :src="hyItem.thumb" alt="">
					</div>
					<div class="title">
						{{hyItem.title}}
					</div>
				</div>
			</div>
		</div>
		<el-dialog
		  v-if="isClose"
		  :visible.sync="dialogVisible"
		  width="60%"
		  ref="vueRef"
		  :before-close="handleClose" style="height:80% !important">
			<video  controls="" loop="" type="video/mp4">
				<source :src="src">
			</video>
		</el-dialog>
	</div>
	
</template>

<script>
	import Axios from 'axios'
	export default {
		data() {
			return {
				isClose:false,
				key: 0,
				dialogVisible:false,
				src:'',
				list:[],
				dpgl:[],
				xxgl:[],
				zhgl:[],
				hyfw:[],
				xtgg:[],
				lygl:[],
				hygl:[],
				isdpgl:false,
				isxxgl:false,
				iszhgl:false,
				ishyfw:false,
				isxtgg:false,
				islygl:false,
				ishygl:false,
				
			}
		},
		
		created() {
			this.getData()
		},
		methods: {
			getData() {
				this.$axios.get(this.$store.state.VIDEO_URL+'/api/course/list').then(data => {
					let datas = data.data
					if(data.code == 1000){
						this.list = datas
						datas.forEach(item=>{
							if(item.groups == "店铺管理"){
								this.dpgl.push(item)
								this.isdpgl = true
							}
							if(item.groups == "信息管理"){
								this.xxgl.push(item)
								this.isxxgl = true
							}
							if(item.groups == "展会管理"){
								this.zhgl.push(item)
								this.iszhgl = true
							}
							if(item.groups == "会员服务"){
								this.hyfw.push(item)
								this.ishyfw = true
							}
							if(item.groups == "系统公告"){
								this.xtgg.push(item)
								this.isxtgg = true
							}
							if(item.groups == "留言管理"){
								this.lygl.push(item)
								this.islygl = true
							}
							if(item.groups == "会员管理"){
								this.hygl.push(item)
								this.ishygl = true
							}
						})
					}
				})
			},
			openWindow(row) {
				this.src = row
				this.isClose = true
				this.dialogVisible = true
			},
			handleClose(){
				this.src = ""
				this.isClose = false
				this.dialogVisible = false
			}
		},
	}
</script>

<style>
	.contens{
		padding:20px;
		background-color: #fff;
	}
	.listBoxs {
		margin-top: 40px;
	}

	.litListBoxs {
		display: inline-block;
	}

	.listBoxs .titles {
		font-size: 16px;
		position: relative;
		margin-left: 12px;
	}

	.listBoxs .titles:after {
		content: '';
		position: absolute;
		top: 0px;
		left: -10px;
		width: 5px;
		height: 15px;
		background: #0194fe;
	}
	video{
		width: 100%;
		height:100%;
	}
	.el-dialog{
		height:80% !important;
	}
	.el-dialog__body{
		height:80% !important;
	}
	.boxCounts {
		margin-top: 20px;
		display: flex;
		flex-wrap: wrap;
	}

	.boxCounts .boxs {
		width: 206px;
		height: 132px;
	}

	.boxCounts .boxs img {
		width: 206px;
		height: 132px;
	}

	.boxCounts .boxs .title {
		text-align: center;
		margin-top: 15px;
	}

	.boxCounts .boxs:not(:nth-child(6n)) {
		margin-bottom: 20px;
		margin-right: calc(370px / 5);
	}
</style>